interface MetricProps {
  label: string
  value: string
  sub?: string
  sample?: boolean
  meta?: string
}

export function Metric({label, value, sub, sample, meta}: MetricProps) {
  return (
    <div className="card rounded-2xl p-4 space-y-2">
      <div className="flex items-center justify-between text-xs text-[#8da0d0]">
        <span>{label}</span>
        {sample && (
          <span className="text-[10px] px-2 py-0.5 rounded bg-[#0b1020] border border-[#1a2236] text-[#7be0b3]">
            sample
          </span>
        )}
      </div>
      <div className="text-2xl">{value}</div>
      {sub && <div className="text-xs text-[#7be0b3]">{sub}</div>}
      {meta && <div className="text-[10px] text-[#5e6b92]">{meta}</div>}
    </div>
  )
}
